import { Button, Card, Form, Popconfirm } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import { ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import ToyEditContent from '../components/ToyEditContent';

const EditToy = (props) => {
  const { match: { params: { id } = {} } = {} } = props;

  const history = useHistory();
  const { state: { showPrompt }, dispatch } = useContext(AppContext);
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isDiscarding, setIsDiscarding] = useState(false);

  useEffect(() => {
    if (isDiscarding && !showPrompt) {
      history?.push(`${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}`);
    }
  }, [history, isDiscarding, showPrompt]);

  const actionButtons = (
    <div className="header-btn-wrapper">
      <Popconfirm
        title="Discard all unsaved changes?"
        okText="Discard"
        cancelText="Cancel"
        onConfirm={() => {
          setIsDiscarding(true);
          dispatch({ type: 'SET_SHOW_PROMPT', data: false });
        }}
      >
        <Button
          type="primary"
          className="common-button mr-16"
          size="middle"
        >
          Discard Changes
        </Button>
      </Popconfirm>
      <Button
        className="common-button"
        size="middle"
        onClick={form.submit}
        loading={isSubmitLoading}
        disabled={isDisabled}
      >
        Save
      </Button>
    </div>
  );

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton customLink={`${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}`} />
        <div className="portal-header">Edit Toy</div>
      </Portal>
      <Portal portalId="header-right-content">{actionButtons}</Portal>
      <Portal portalId="header-right-content-phones">{actionButtons}</Portal>
      <Card className="full-height-with-nav" title="Toy Details">
        <ToyEditContent
          form={form}
          toyId={id}
          onSaved={() =>
            history?.replace(`${ROUTES?.MASTER_LISTS}${ROUTES?.TOY}`)
          }
          onDirtyChange={() => setIsDisabled(false)}
          onSubmittingChange={setIsSubmitLoading}
        />
      </Card>
    </>
  );
};

export default EditToy;
